import moment from 'moment'

export function getTimeSeriesNamesList(datasets) {
  let names = datasets.map(x => x.DataSetIdentifer.substring(
    x.DataSetIdentifer.indexOf('.') + 1,
    x.DataSetIdentifer.indexOf('@')
  ))
  let uniqueNames = names.filter((item, index) => names.indexOf(item) === index)
  return uniqueNames
}

const extractName = (dataset) => dataset.DataSetIdentifer.substring(dataset.DataSetIdentifer.indexOf('.') + 1, dataset.DataSetIdentifer.indexOf('@'))

export const addTimeSeriesDisplayNames = (datasets) => datasets.map(dataset => ({
  ...dataset,
  displayName: extractName(dataset),
}))


export function getDataTimeRange(datasets) {
  let validStartDates = datasets.map(x => x.FirstRecordDate).filter(date => date != null)
  let validEndDates = datasets.map(x => x.LastRecordDate).filter(date => date != null)
  let allStartDate = validStartDates.map(x => moment(x).valueOf())
  let allEndDate = validEndDates.map(x => moment(x).valueOf())
  let minDate = Math.min.apply(Math, allStartDate)
  let maxDate = Math.max.apply(Math, allEndDate)
  return [moment(minDate), moment(maxDate)]
}